import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initSentry } from './helpers/report';

initSentry();

ReactDOM.render(<App />, document.getElementById('root'));
